import React, { useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@mui/styles';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import {
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination
} from '@mui/material';

import { useHistory } from "react-router-dom";
import Button from "@mui/material/Button";
import { updateSelectedBookingSessionIds, setBookingSessionDetail } from 'store/actions/restaurant'
import { useDispatch, useSelector } from 'react-redux';
import { ListCard, ListCardField, ListCards } from 'components';
import useCompactLayout from 'hooks/useCompactLayout';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
   // minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  textLink: {
		textDecoration: 'underline',
	},
}));

const BookingSessionsTable = props => {
  const { className,  sessions, ...rest } = props;
  const dispatch = useDispatch();
  const isCompact = useCompactLayout();
  const classes = useStyles();
 
  const history = useHistory();
  const [selectedSessions, setSelectedSessions] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [page, setPage] = useState(0);
  const updateBookingSessionIds = (ids) => dispatch(updateSelectedBookingSessionIds(ids));
  const updateBookingSessionDetails = (session) => dispatch(setBookingSessionDetail(session));
  

  const handleSelectAll = event => {
    const { restaurants } = props;

    let selectedRestaurants;

    if (event.target.checked) {
      selectedRestaurants = restaurants.map(restaurant => restaurant.urlIdentifier);
    } else {
      selectedRestaurants = [];
    }

    setSelectedSessions(selectedRestaurants);
  };

  const handleSelectOne = (event, sessionId) => {
    const selectedIndex = selectedSessions.indexOf(sessionId);
    let newSelectedSessions = [];

    if (selectedIndex === -1) {
      newSelectedSessions = newSelectedSessions.concat(selectedSessions, sessionId);
    } else if (selectedIndex === 0) {
      newSelectedSessions = newSelectedSessions.concat(selectedSessions.slice(1));
    } else if (selectedIndex === selectedSessions.length - 1) {
      newSelectedSessions = newSelectedSessions.concat(selectedSessions.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedSessions = newSelectedSessions.concat(
        selectedSessions.slice(0, selectedIndex),
        selectedSessions.slice(selectedIndex + 1)
      );
    }

    setSelectedSessions(newSelectedSessions);
    updateBookingSessionIds(newSelectedSessions);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };

  const openSessionDetail = (e, session) => {
    updateBookingSessionDetails(session);
    history.push(`/bookingSession/${session.sessionId}`);
  };


  // One slice, shared by both layouts, so page state survives a resize.
  const sortedSessions = [...sessions].sort((a, b) => a.startTime.localeCompare(b.startTime));
  const pagedSessions = sortedSessions.slice(page * rowsPerPage, rowsPerPage * page + rowsPerPage);

  const sessionUpdatedAt = (session) =>
    session.updatedAt && session.updatedAt._seconds
      ? moment(new Date(session.updatedAt._seconds * 1000)).format('DD/MM/YYYY')
      : '';

  const renderCards = () => (
    <ListCards count={sessions.length} noun="session" empty="No booking sessions to show.">
      {pagedSessions.map(session => (
        <ListCard
          key={session.sessionId}
          data-testid="booking-session-card"
          header={
            <>
              <Checkbox
                checked={selectedSessions.indexOf(session.sessionId) !== -1}
                color="primary"
                onChange={event => handleSelectOne(event, session.sessionId)}
                size="small"
                inputProps={{ 'aria-label': `select session ${session.name}` }}
              />
              <Button onClick={e => openSessionDetail(e, session)} style={{ flex: 1, minWidth: 0, justifyContent: 'flex-start' }}>
                <div className={classes.textLink}>
                  <Typography variant="body1">{session.name}</Typography>
                </div>
              </Button>
            </>
          }
        >
          <ListCardField label="Time" value={`${session.startTime} - ${session.endTime}`} />
          <ListCardField label="Guests" value={session.guestNum} />
          <ListCardField label="Deposit" value={session.depositRequired ? 'Yes' : 'No'} />
          <ListCardField label="Updated" value={sessionUpdatedAt(session)} />
        </ListCard>
      ))}
    </ListCards>
  );

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent className={classes.content}>
        {isCompact ? renderCards() : (
        <PerfectScrollbar>
          <div className={classes.inner}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell >
                    
                  </TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Total Guests</TableCell>
                  <TableCell>Start Time - End Time</TableCell>
                 
                  <TableCell>Require Deposit</TableCell>
                  <TableCell>Updated At</TableCell>
              
                </TableRow>
              </TableHead>
              <TableBody>
                {pagedSessions.map(session => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={session.sessionId}
                    selected={selectedSessions.indexOf(session.sessionId) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedSessions.indexOf(session.sessionId) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, session.sessionId)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell >

                    <Button onClick={e => openSessionDetail(e, session)}>
                        <div className={classes.textLink}>
                          <Typography variant="body1">{session.name}</Typography>
                        </div>
                      </Button>

                     
                    </TableCell>
                    <TableCell>{session.guestNum}</TableCell>
                    <TableCell>{`${session.startTime} - ${session.endTime}`}</TableCell>
                    <TableCell>{session.depositRequired ? 'Yes' : 'No'}</TableCell>
                   
                  
                    <TableCell>{sessionUpdatedAt(session)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            </TableContainer>
          </div>
        </PerfectScrollbar>
        )}
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={sessions.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

BookingSessionsTable.propTypes = {
  className: PropTypes.string,
  sessions: PropTypes.array.isRequired
};

export default BookingSessionsTable;
